// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"899":"99d90c72816d36d4","966":"a0084e3520522897"}[chunkId] + ".js";
};